import VerticalServiceModel from "../../../services/interfaces/VerticalServiceModel";
import { PurchasingPlanEntity } from "../../../services/purchasingContractingPlan/entity/PurchasingPlanEntity";
import { PurchasingPhaseENUM } from "./PurchasingPhaseENUM";
import { PurchasingPlanStatusENUM } from "./PurchasingPlanStatusENUM";

interface IResponsibleUser {
  id: number;
  name: string;
}

export interface PurchasingItem {
  id?: number;
  name: string;
  quantity: number;
  unit: string;
  specifications: string;
  cost: number;
}

interface PurchasingModel {
  id?: number;
  name: string;
  specifications?: string;
  unit?: string;
  cost?: number;
  quantity?: number;
  supplierQuotationDate?: Date;
  purchasingDateLimit?: Date;
  deliveryDateLimit?: Date;
  supplierQuotationDays?: number;
  purchasingLimitDays?: number;
  purchaseLimitDate?: string;
  deliveryLimitDays?: number;
  deliveryLimitDate?: string;
  securityDays?: number;
  status?: PurchasingPlanStatusENUM;
  phase?: PurchasingPhaseENUM;
  isPhaseInitiated?: boolean;
  responsisbleName?: string;
  responsibleId?: number;
  responsibleRole?: number;
  requesterResponsableId?: number;
  requesterResponsable?: IResponsibleUser;
  supplierQuotatioResponsableId?: number;
  supplierQuotatioResponsable?: IResponsibleUser;
  approveResponsableId?: number;
  approveResponsable?: IResponsibleUser;
  purchasingResponsableId?: number;
  purchasingResponsable?: IResponsibleUser;
  finishPlanResponsableId?: number;
  finishPlanResponsable?: IResponsibleUser;
  services: VerticalServiceModel[];
  supplierQuotationStartDate?: string;
  supplierQuotationFinishedDate?: string;
  approveStartDate?: string;
  approveFinishedDate?: string;
  purchasingStartDate?: string;
  purchasingFinishedDate?: string;
  approveReceiptStartDate?: string;
  approveReceiptFinishedDate?: string;
  description?: string;
  purchasingItems?: PurchasingItem[];
}

export const parsePurchasingEntityToModel = (
  item: PurchasingPlanEntity
): PurchasingModel => {
  return {
    id: item.id || 0,
    name: item.name,
    cost: item.cost,
    supplierQuotationDate: item.supplierQuotationDate
      ? new Date(item.supplierQuotationDate)
      : undefined,
    purchasingDateLimit: item.purchasingLimitDate
      ? new Date(item.purchasingLimitDate)
      : undefined,
    deliveryDateLimit: item.deliveryLimitDate
      ? new Date(item.deliveryLimitDate)
      : undefined,
    securityDays: item.safetyDays,
    supplierQuotationDays: item.supplierQuotationDays,
    purchasingLimitDays: item.purchasingLimitDays,
    deliveryLimitDays: item.deliveryLimitDays,
    status: item.status,
    phase: item.phase,
    isPhaseInitiated: item.isPhaseInitiated === true,
    responsisbleName: item.currentResponsible?.name || undefined,
    responsibleId: item.currentResponsible?.id || undefined,
    responsibleRole: item.currentResponsible?.role || undefined,
    services: item.verticalServices,
    requesterResponsable: item.requesterResponsable,
    requesterResponsableId: item.requesterResponsableId,
    supplierQuotatioResponsable: item.supplierQuotatioResponsable,
    supplierQuotatioResponsableId: item.supplierQuotatioResponsableId,
    approveResponsable: item.approveResponsable,
    approveResponsableId: item.approveResponsableId,
    purchasingResponsable: item.purchasingResponsable,
    purchasingResponsableId: item.purchasingResponsableId,
    finishPlanResponsable: item.approveReceiptResponsible,
    finishPlanResponsableId: item.approveReceiptResponsibleId,
    supplierQuotationStartDate: item.supplierQuotationStartDate,
    supplierQuotationFinishedDate: item.supplierQuotationFinishedDate,
    approveStartDate: item.approveStartDate,
    approveFinishedDate: item.approveFinishedDate,
    purchasingStartDate: item.purchasingStartDate,
    purchasingFinishedDate: item.purchasingFinishedDate,
    approveReceiptStartDate: item.approveReceiptStartDate,
    approveReceiptFinishedDate: item.approveReceiptFinishedDate,
    purchasingItems: item.purchasingItems,
  } as PurchasingModel;
};

export default PurchasingModel;
